export default {
  title01: "מזג אוויר נוכחי",
  title02: " שעות",
  title03: "הצג תחזית מזג אוויר ל-10 ימים",
  title04: "AQI",
  title05: "ראה את כל המידע",
  title06: "זריחה ושקיעה",
  title07: "מופע הירח",
  title08: "הירח המלא הבא",
  title09: "הירח החדש הבא",
  title10: "ום",
  title11: "לילה",
  title12: "זריחה",
  title13: "שקיעה",
  title14: "זריחת ירח",
  title15: "שקיעה של ירח",
  title16: "מקור",
  title17: "התחל",
  title18: "סוף",
  title19: "השתמש במיקום נוכחי",
  title20: "חפש בעיר",
  title21: "מרגיש כמו",
  title22: "מרגיש כמו צל",
  title23: "עכשיו",
  title24: "היום",
  title25: "יום ראשון",
  title26: "יום שני",
  title27: "יום שלישי",
  title28: "יום רביעי",
  title29: "יום חמישי",
  title30: "יום שישי",
  title31: "יום שבת",
  title32: "טוען...",
  title33: "עכשיו",
  title34: "שָׁעוֹנִי",
  title35: "יומי",
  title36: "שמש וירח",
  title37: "איכות האוויר",
  title38: "יצירת קשר: xlf550402@gmail.com",
  title39: "הסכם פרטיות",
  title40: "זכויות יוצרים © comfortweather.com 2020 - 2024. כל הזכויות שמורות.",
  title41: "נתונים מסופקים על ידי",
  title42: "היי",
  title43: "לו",
  title44: "קבל",
  title45: "תודה על השימוש ב-ComfortWeather! כדי להגן טוב יותר על הזכויות והאינטרסים המשפטיים שלך, אנא קרא את ה ",
  title46: "מדיניות פרטיות",
  title47: " בזהירות לפני השימוש.",
  title48: "",
  title49: "יצירת קשר: xyjph123@gmail.com",
  title50: "זכויות יוצרים © 24hweather.com 2020 - 2024. כל הזכויות שמורות.",
  title51: "תודה על השימוש ב-ComfortWeather! כדי להגן טוב יותר על הזכויות והאינטרסים המשפטיים שלך, אנא קרא את ה ",
};